var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoginPage"},[_c('b-button',{staticClass:"mr-2 ml-2 p-2",attrs:{"variant":"primary"},on:{"click":_vm.handleLoginRequest}},[_vm._v(" Sign in ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }